import { type ReactNode } from "react";

import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Card, Typography } from "@mui/material";
import { Box } from "@mui/system";

import { mixpanelTrack } from "../../../utils/mixpanel";

export type Props = {
  icon: ReactNode;
  iconText: string;
  title: string;
  description: string;
  link: string;
  linkText: string;
  feature: string;
};

export const QuickLinkCard = ({ icon, iconText, title, description, link, linkText, feature }: Props) => (
  <Link
    to={link}
    style={{ textDecoration: "none" }}
    onClick={() => {
      mixpanelTrack("Home feature card clicked", {
        feature,
      });
    }}
  >
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:hover": { borderColor: "primary.main" },
        p: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 30,
            height: 30,
            bgcolor: "general.iconBackground",
            borderRadius: 1,
            mr: 1,
          }}
        >
          {icon}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          {iconText}
        </Typography>
      </Box>

      <Typography variant="h5" component="h2" sx={{ mb: 1, fontWeight: 500 }}>
        {title}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {description}
      </Typography>

      <Box
        sx={{
          mt: "auto",
          pt: 1.5,
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }} data-cy="quick-link-card-link">
          <ArrowForwardIcon fontSize="small" sx={{ mr: 1 }} color="primary" />
          <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 500 }}>
            {linkText}
          </Typography>
        </Box>
      </Box>
    </Card>
  </Link>
);
